/* eslint-disable react/no-array-index-key */
import React from "react";
import "./SessionItem.css";
import moment from "moment";
import Locale from "../../../locales";

const SessionItem = ({ session }) => {
  const { title, sessionDuration, startDate, startTime, sessionEvents } =
    session;
  return (
    <div className="sessions-tasks-list-item">
      <div className="sessions-tasks-item-header">
        <h2>{title}</h2>
      </div>
      <div className="sessions-tasks-list-details">
        <h3>
          {Locale.t("start_time")}:
          <span>
            {moment(new Date(`${startDate} ${startTime}`)).format("hh:mm a")}
          </span>
        </h3>
        <h3>
          {Locale.t("total_duration")} :
          <span>
            {Locale.t("mins").replace("{{duration}}", sessionDuration)}
          </span>
        </h3>
      </div>
      <div className="session-task-list-container">
        <h2>{Locale.t("tasks")}:</h2>
        {sessionEvents.map((task, index) => {
          const { description, title: taskTitle, duration } = task;
          return (
            <div className="session-task-list-item" key={index}>
              <h3>{taskTitle}</h3>
              <h5>{description}</h5>
              <h4>{Locale.t("mins").replace("{{duration}}", duration)}</h4>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SessionItem;
